import { Button, Modal } from "antd";
import { useState } from "react";
import useCreate from "hooks/useCreate";

const DeleteSelected = ({ issue_group_id, ids, refetch, clearSelected }) => {
  const [is_open, setOpen] = useState(false);

  const { is_deleting, create: removeSubIssues } = useCreate({
    path: `/issue_groups/${issue_group_id}/bulk_remove_sub_issues`,
    onSuccess: () => [refetch(), clearSelected(), setOpen(false)],
    success_message: `Usunięto ${
      ids?.length > 2 ? "podzgłoszenia" : "podzgłoszenie"
    }`,
  });

  return (
    <>
      <Button danger onClick={() => setOpen(true)}>
        Usuń zaznaczone
      </Button>
      {is_open && (
        <Modal
          style={{ top: 45 }}
          title="Potwierdzenie"
          open={is_open}
          onOk={() => removeSubIssues({ ids })}
          okButtonProps={{ loading: is_deleting }}
          onCancel={() => setOpen(false)}
          cancelText="Anuluj"
          okText="Potwierdzam"
          okType="danger"
        >
          Czy na pewno chcesz usunąć zaznaczone podzgłoszenia?
        </Modal>
      )}
    </>
  );
};

export default DeleteSelected;
